import React from 'react';

import { format } from 'date-fns';

import IconButton from 'CommonComponents/IconButton';
import TableRowSkeleton from 'CommonComponents/TableRowSkeleton';

import CheckIcon from 'Assets/icons/check.svg';
import CircleCheckIcon from 'Assets/icons/circle-check.svg';
import DownloadIcon from 'Assets/icons/download.svg';
import EditIcon from 'Assets/icons/edit.svg';
import HourglassIcon from 'Assets/icons/hourglass.svg';
import PlusIcon from 'Assets/icons/plus.svg';
import TrashIcon from 'Assets/icons/trash.svg';
import XMarkIcon from 'Assets/icons/xmark-2.svg';

export default function AttachmentsTable({
    attachments,
    isLoading,
    editingDescription,
    setDescriptionText,
    descriptionText,
    startEditDescription,
    cancelEditDescription,
    handleUpdateDescription,
    handleDownload,
    handleDelete,
}) {
    const formatDate = (dateString) => {
        if (!dateString) return '-';
        return format(new Date(dateString), 'yyyy-MM-dd HH:mm:ss');
    };

    return (
        <div className="inbud-table_wrapper">
            <table className="inbud-table tw-table-fixed">
                <thead>
                    <tr>
                        <th className="tw-w-96">{$t('Name')}</th>
                        <th>{$t('Description')}</th>
                        <th className="tw-w-24">{$t('Format')}</th>
                        <th className="tw-w-24">{$t('Size')}</th>
                        <th className="tw-w-24">{$t('Status')}</th>
                        <th className="tw-w-32">{$t('Uploaded By')}</th>
                        <th className="tw-w-40">{$t('Uploaded At')}</th>
                        <th className="tw-w-16">{$t('Actions')}</th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading ? (
                        <TableRowSkeleton rows={5} columns={8} />
                    ) : (
                        attachments.map((attachment) => (
                            <tr key={attachment.id} className="hover:tw-bg-gray-50">
                                <td>
                                    <div className="tw-truncate">{attachment.original_filename}</div>
                                </td>
                                <td>
                                    {editingDescription === attachment.id ? (
                                        <div className="tw-flex tw-items-center tw-gap-2">
                                            <input
                                                type="text"
                                                value={descriptionText}
                                                className="text-input"
                                                placeholder={$t('Enter description...')}
                                                autoFocus
                                                onChange={(e) => setDescriptionText(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleUpdateDescription(attachment);
                                                    } else if (e.key === 'Escape') {
                                                        cancelEditDescription();
                                                    }
                                                }}
                                            />
                                            <div className="tw-flex tw-items-center tw-gap-1">
                                                <IconButton variant="success" size="sm" ghost onClick={() => handleUpdateDescription(attachment)}>
                                                    <CheckIcon className="tw-w-3 tw-h-3" />
                                                </IconButton>
                                                <IconButton variant="danger" size="sm" ghost onClick={cancelEditDescription}>
                                                    <XMarkIcon className="tw-w-3 tw-h-3" />
                                                </IconButton>
                                            </div>
                                        </div>
                                    ) : (
                                        <div
                                            className="tw-cursor-pointer hover:tw-text-black tw-flex tw-items-center tw-gap-1"
                                            onClick={() => startEditDescription(attachment)}
                                        >
                                            {attachment.description || <span className="tw-italic tw-text-charcoal-25">{$t('Add description')}</span>}
                                            {attachment.description ? (
                                                <EditIcon className="tw-w-3 tw-h-3" />
                                            ) : (
                                                <PlusIcon className="tw-w-3 tw-h-3 tw-text-charcoal-25" />
                                            )}
                                        </div>
                                    )}
                                </td>
                                <td>{attachment.format}</td>
                                <td>{attachment.human_readable_size}</td>
                                <td>
                                    {attachment.is_uploaded ? (
                                        <span className="tw-flex tw-items-center tw-gap-1 tw-text-green-600">
                                            <CircleCheckIcon className="tw-w-3 tw-h-3" />
                                            {$t('Uploaded')}
                                        </span>
                                    ) : (
                                        <span className="tw-flex tw-items-center tw-gap-1 tw-text-yellow-600">
                                            <HourglassIcon className="tw-w-3 tw-h-3" />
                                            {$t('Processing')}
                                        </span>
                                    )}
                                </td>
                                <td>
                                    <div className="tw-truncate">{attachment.uploader ? attachment.uploader.name : '-'}</div>
                                </td>
                                <td className="inbud-date-cell">{formatDate(attachment.created_at)}</td>
                                <td>
                                    {attachment.is_uploaded && (
                                        <div className="tw-flex tw-items-center tw-gap-1 -tw-my-1.5">
                                            <IconButton onClick={() => handleDownload(attachment)} variant="primary" size="sm" ghost title={$t('Download')}>
                                                <DownloadIcon className="tw-w-3 tw-h-3" />
                                            </IconButton>
                                            <IconButton onClick={() => handleDelete(attachment)} variant="danger" size="sm" ghost title={$t('Delete')}>
                                                <TrashIcon className="tw-w-3 tw-h-3" />
                                            </IconButton>
                                        </div>
                                    )}
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}
